//import JSZip from "jszip";

export async function validateZipFile(file: File) {
    return null;
    /*
    const inputZip = new JSZip();
    try {
        const zipFiles = await inputZip.loadAsync(file);
        const files = Object.keys(zipFiles.files);
        if (
            !files.find(
                f =>
                    (f.includes("F100") || f.includes("F109") || f.includes("F308")) &&
                    (f.endsWith(".zip") || f.endsWith(".uct"))
            )
        )
            return "Missing F100, F109, or F308 file in the zip, please try again";
        if (!files.find(f => (f.includes("F101") || f.includes("F110")) && f.endsWith(".xml")))
            return "Missing F101 or F110 file in the zip, please try again";
        if (!files.find(f => f.includes("F112") && f.endsWith(".xml")))
            return "Missing F112 file in the zip, please try again";
        if (!files.find(f => f.includes("F212") && f.endsWith(".zip")))
            return "Missing F212 file in the zip, please try again";
        if (!files.find(f => f.includes("F226") && f.endsWith(".xml")))
            return "Missing F226 file in the zip, please try again";
        if (!files.find(f => (f.includes("F301") || f.includes("F312")) && f.endsWith(".xml")))
            return "Missing F301 or F312 file in the zip, please try again";
        if (!files.find(f => f.includes("F320") && f.endsWith(".zip")))
            return "Missing F320 file in the zip, please try again";
        if (
            !files.find(
                f =>
                    (f.includes("_CORE_FB_DA_CBCORA_") || f.includes("_CORE_FB_DA_RA_")) &&
                    f.endsWith(".xlsx")
            )
        )
            return "Missing CORE_FB_DA_CBCORA or CORE_FB_DA_RA file in the zip, please try again";
        //No errors
        return null;
    } catch {
        return "Unable to extract zip file, please try again";
    }
    */
}

export const checkFileNameTimestamp = (fileName: string) => {
    try {
        let name = fileName.slice(0, 8);
        const FILE_PATTERN = /^([^_]+)_(\d{8})_(ID|DA|LT)_([vV])(\d+)_input_validation_(.{0,5})*\.zip$/;
        //Use node ES2018 + in tsconfig.json
        /*
        const FILE_PATTERN = /^(?<tso_name>[^_]+)_(?<business_date>\d{8})_(?<business_type>ID|DA|LT)_(?<file_version_prefix>[vV])(?<file_version>\d+)_input_validation_(?<optional_chars>.{0,5})*\.zip$/;
        */
        const match = fileName.match(FILE_PATTERN);
        if (match) {
            const businessDate = match[2]; //(?<business_date>\d{8})
            name = businessDate;
        }
        const timestamp = name.slice(0, 4) + "-" + name.slice(4, 6) + "-" + name.slice(6);
        if (timestamp === new Date(timestamp).toISOString().split("T")[0]) return timestamp;
        else return "";
    } catch {
        return "";
    }
};
